import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';

@Component({
    selector: 'app-input-radio',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputRadioComponent,
            multi: true
        }
    ],
    templateUrl: './input-radio.component.html',
    styleUrls: ['./input-radio.component.scss']
})
export class InputRadioComponent implements ControlValueAccessor {
    @Input() label: string = '';
    @Input() value: any; // The value of this radio button
    @Input() group: string;
    @Input() formControl: FormControl;

    @Output() select = new EventEmitter<any>();

    currentValue: any;

    private onChangeCallback: (_: any) => void = () => {
    };
    private onTouchedCallback: () => void = () => {
    };

    // Called by Angular to write a new value to the control
    writeValue(value: any): void {
        this.currentValue = value;
    }

    // Register a function to be called when the control value changes
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    // Register a function to be called when the control is touched
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    // Handle selection
    selection(): void {
        this.currentValue = this.value;
        if (this.onChangeCallback) {
            this.onChangeCallback(this.currentValue); // Notify Angular forms of value change
        }
        if (this.onTouchedCallback) {
            this.onTouchedCallback(); // Mark as touched
        }
        this.select.emit(this.value); // Emit value to parent if needed
    }
}
